import { mdStyle, smStyle } from '@/components/Adapter'
import { Flex } from '@mantine/core'
import styled from 'styled-components'

export const CoinPriceStyled = styled(Flex)`
  .coin-price-title {
    font-size: 28px;

    ${smStyle} {
      font-size: 32px;
      max-width: 384px;
    }

    ${mdStyle} {
      font-size: 40px;

      &[data-size='14'] {
        font-size: 32px;
      }

      &[data-size='18'] {
        font-size: 28px;
      }

      &[data-size='21'] {
        font-size: 24px;
        max-width: 308px;
      }
    }
  }

  .coin-price-dimension_24h {
    font-size: 14px;

    ${smStyle} {
      font-size: 18px;
    }

    ${mdStyle} {
      font-size: 20px;

      &[data-size='14'] {
        font-size: 18px;
      }

      &[data-size='18'] {
        font-size: 16px;
      }

      &[data-size='21'] {
        font-size: 14px;
        white-space: nowrap;
      }
    }
  }
`
